import { ServiceTypeModel } from "../../../entities";
import { BaseDataRepository } from "../../BaseDataRepository";
export class ServiceTypeRepo extends BaseDataRepository<ServiceTypeModel> {
  protected baseUrl = 'servicetype';
}

export default ServiceTypeRepo;
